import { MoveActionMsg } from 'src/types/ViewModel/ActionMsg';

/**
 * Empty move action message object for initializing port calls
 */
// TODO: FUNCTION-MUTATION - Object should be frozen to prevent external mutation
export const emptyMoveActionMsg: MoveActionMsg = {
    displayMoveIcon: false,
    message: null,
    doAction: false,
    toolTipText: null,
    moveToNodeText: null,
    id: null,
};
